import React from 'react';
import { isNullOrUndefined } from 'utils/Global';
import './ExperimentSidebarButtons.scss';

const ExperimentSidebarButtons = ({ height, width, buttons }: any) => {
  const actionBtns = [];
  let btnview;
  if (buttons) {
    for (let i = 0; i < buttons.length; i += 1) {
      const button = buttons[i];
      if (isNullOrUndefined(button)) {
        continue;
      }

      btnview = (
        <div
          id={`experiment-sidebar-button-${button.title}`}
          className={
            button.isDisabled
              ? 'main-container-disabled'
              : button.showActive
              ? 'main-container-active enabledDiv'
              : 'main-container enabledDiv'
          }
          style={{
            marginLeft: i != 0 ? '2%' : 0,
          }}
          onClick={button.isDisabled ? null : button.onClick}
        >
          <div
            id={`experiment-sidebar-button-${button.title}-icon-container`}
            className="icon-container"
          >
            <div
              id={`experiment-sidebar-button-${button.title}-icon-style`}
              className="icon-style"
            >
              {button.Icon}
            </div>
          </div>

          <div
            id={`experiment-sidebar-button-${button.title}-divider-line`}
            className="divider-line"
          />
          <div
            id={`experiment-sidebar-button-${button.title}-title-container`}
            className="title-container"
          >
            {button.title}
          </div>
        </div>
      );

      actionBtns.push(btnview);
    }
  }
  return (
    <div
      id="experiment-sidebar-buttons"
      className="flex-y-center"
      style={{
        height: height,
        width: width,
        overflow: 'auto',
      }}
    >
      {actionBtns}
    </div>
  );
};

export default ExperimentSidebarButtons;
